import {useQuery} from "react-query";
import api from "../api";

export const useGetPropertyCountries = () => {
    return useQuery(["countries"], () => {
        return api.get("/property/countries").then((res) => res.data);
    });
}